import React from 'react'
import { motion } from 'framer-motion'
import { Download, ArrowRight, Smartphone, Globe } from 'lucide-react'

const Hero: React.FC = () => {
  return (
    <section className="min-h-screen flex items-center justify-center pt-20 pb-8 px-4 gradient-bg relative overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10 text-center max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          {/* App图标 */}
          <motion.div 
            className="w-24 h-24 mx-auto mb-6 rounded-3xl shadow-2xl overflow-hidden"
            whileHover={{ scale: 1.1, rotate: 5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <img src="/app-icon.png" alt="漫时光" className="w-full h-full object-cover" />
          </motion.div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            漫时光
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-2">
            版本迁移指南
          </p>
          <p className="text-lg text-white/80">
            从中国区App Store迁移到外区App Store
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-8"
        >
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="flex items-center justify-center space-x-4 mb-4">
              <div className="flex items-center space-x-2 text-white">
                <Smartphone className="w-5 h-5" />
                <span className="text-sm">版本 1.0</span>
              </div>
              <ArrowRight className="w-5 h-5 text-white" />
              <div className="flex items-center space-x-2 text-white">
                <Globe className="w-5 h-5" />
                <span className="text-sm">版本 1.1</span>
              </div>
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              由于中国区App Store政策调整，漫时光1.1版本已在中国区下架。
              为了获得最新功能和更好的体验，请按照以下指南迁移到外区App Store。
              全程不卸载原App，所有数据都会自动保留。
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <motion.button
            className="btn-primary flex items-center justify-center space-x-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              // 滚动到迁移步骤区域
              const migrationSection = document.querySelector('#migration-steps');
              if (migrationSection) {
                migrationSection.scrollIntoView({ 
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            }}
          >
            <Download className="w-5 h-5" />
            <span>开始迁移</span>
          </motion.button>
          
          <motion.button
            className="btn-secondary flex items-center justify-center space-x-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              // 滚动到FAQ区域
              const faqSection = document.querySelector('#faq-section');
              if (faqSection) {
                faqSection.scrollIntoView({ 
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            }}
          >
            <span>了解更多</span>
            <ArrowRight className="w-4 h-4" />
          </motion.button>
        </motion.div>
      </div>
      
      {/* 滚动提示 */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-bounce"></div>
        </div>
      </motion.div>
    </section>
  )
}



export default Hero
